import { styled } from '@mui/material/styles';
import { Box } from '@sunwisesoftware/sunwise-ui';

export default styled(Box)`
    height: 100%;
    padding: 16px;
    position: relative;
    width: 100%;
`;
